import { rest } from 'msw';
import { getEnv } from 'util/getEnv';
import {
  loyaltyHistory,
  loyaltySpecs,
  redeemPoints,
  accountLoyaltyHistory,
} from './fixtures/loyalty-domain.fixture';

export const listLoyaltyHistoryMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-loyalty-domain/clients/:clientId/loyaltyaccounts/:userId/accounthistory`,
    fn,
  );

export const redeemLoyaltyPointsMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-loyalty-domain/redeempoints`,
    fn,
  );

export const getLoyaltySpecMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-loyalty-domain/clients/:clientId/loyaltyspec/:merchantId`,
    fn,
  );

export const updateLoyaltySpecsMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-loyalty-domain/clients/:clientId/loyaltyspec/:merchantId`,
    fn,
  );

export const accountLoyaltySummarySpecMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-loyalty-domain/clients/:clientId/loyaltyaccounts/:userId`,
    fn,
  );

export const handlers = () => [
  listLoyaltyHistoryMock((req, res, ctx) => {
    return res(ctx.json(loyaltyHistory));
  }),
  redeemLoyaltyPointsMock((req, res, ctx) => {
    return res(ctx.json(redeemPoints));
  }),
  getLoyaltySpecMock((_req, res, ctx) => {
    return res(ctx.json(loyaltySpecs));
  }),
  updateLoyaltySpecsMock((req, res, ctx) => {
    return res(ctx.json(req.body));
  }),
  accountLoyaltySummarySpecMock((req, res, ctx) => {
    return res(ctx.json(accountLoyaltyHistory));
  }),
];
